import React from 'react'
import { Button } from 'antd'
import { Link } from 'react-router-dom'
import ContentLoader from 'react-content-loader'

import ApplicationIcon from 'assets/images/ekko-o-cropped.png'

const Stylesheet = {
    desc: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        marginLeft: 50,
        alignItems: 'center'
    }
}

function ApplicationCardListItem({ data }) {
    const { name, id } = data
    // const created_at = new Date(data.created_at)
    // const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }

    return (
        <div className="gx-user-list gx-card-list">
            <img alt="..." src={ApplicationIcon} style={{ height: 50, width: 50 }} />

            <div style={Stylesheet.desc}>
                <h2>{name}</h2>
                {/* <h3>{created_at.toLocaleDateString('en-EN', options)}</h3> */}
            </div>

            <div className="gx-card-list-footer">
                <Link to={`/${id}/dashboard`}>
                    <Button type="primary">Manage</Button>
                </Link>
            </div>
        </div>
    )
}

function ApplicationCardListItemPlaceholder() {
    return (
        <div>
            {[1, 2, 3, 4, 5].map(data => (
                <ContentLoader
                    key={data}
                    style={{ height: 110, width: '100%', paddingBottom: 32 }}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="5" ry="5" width="9999" height="99999" />
                </ContentLoader>
            ))}
        </div>
    )
}

export { ApplicationCardListItem, ApplicationCardListItemPlaceholder }
